import { ActionSheet, ActionSheetButtonStyle } from '@capacitor/action-sheet'

import { ToolBox } from './toolBox'

type Props = {
  title: string
  message?: string
  options: Array<{ label: string }>
  onItemClick: (option: unknown) => void
}

export function useActionSheet({ title, message, options, onItemClick }: Props) {
  const { tComponent } = ToolBox.useString()

  const translate = (id: string) => {
    return tComponent({
      id,
      componentType: 'hooks',
      componentName: 'use_action_sheet'
    })
  }

  const showActions = async () => {
    const promptRet = await ActionSheet.showActions({
      title,
      message: message || translate('default_message'),
      options: [
        ...options.map((option) => ({ title: option.label })),
        {
          title: translate('cancel'),
          style: ActionSheetButtonStyle.Destructive
        }
      ]
    })
    options[promptRet.index] && onItemClick(options[promptRet.index])
  }

  return { showActions }
}
